import React from 'react';
import { formatReputationDate, getLinkTypeMeta } from '../subparts/reputationQuery';

function ReputationLinkTab({ reputationLinks }) {
    const hasLinks = reputationLinks.length > 0;

    return (
        <div>
            <div className="reputation-section">
                <div>
                    <h2 className="reputation-section__title">
                        <i className="bi bi-link-45deg me-2"></i>
                        Reputation Links
                    </h2>
                    <p className="reputation-section__subtitle">
                        Social and review platform links connected to your reputation page
                    </p>
                </div>
                <div className="reputation-section__actions">
                    <span className="ecx-page-chip">
                        <i className="bi bi-link-45deg"></i>
                        {reputationLinks.length} link{reputationLinks.length === 1 ? '' : 's'}
                    </span>
                </div>
            </div>

            {hasLinks ? (
                <div className="table-responsive reputation-table-wrap">
                    <table className="table table-hover align-middle mb-0">
                        <thead>
                            <tr>
                                <th>Platform</th>
                                <th>Link</th>
                                <th>Status</th>
                                <th>Created</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reputationLinks.map((link) => {
                                const linkMeta = getLinkTypeMeta(link.linkType);

                                return (
                                    <tr key={link.id}>
                                        <td>
                                            <div className="d-flex align-items-center gap-2">
                                                <span className={linkMeta.className}>
                                                    <i className={`bi ${linkMeta.icon}`}></i>
                                                </span>
                                                <span className="fw-semibold text-dark">{link.linkType}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <a
                                                href={link.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="reputation-link-url"
                                            >
                                                {link.link}
                                            </a>
                                        </td>
                                        <td>
                                            <span
                                                className={`reputation-active-badge ${
                                                    link.isActive ? 'is-active' : 'is-inactive'
                                                }`}
                                            >
                                                <i className={`bi ${link.isActive ? 'bi-check-circle' : 'bi-pause-circle'}`}></i>
                                                {link.isActive ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td className="text-muted small">{formatReputationDate(link.createdAt)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="ecx-page-empty">
                    <span className="ecx-page-empty__icon">
                        <i className="bi bi-link-45deg"></i>
                    </span>
                    <h3 className="h6 fw-bold text-dark mb-1">No reputation links</h3>
                    <p className="mb-0 small">Links to your social media and review platforms will appear here.</p>
                </div>
            )}
        </div>
    );
}

export default ReputationLinkTab;
